<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <CompanyBreadcrumb :aria-label="pageTitle"
                           :home-aria-label="$t('general.home')"
                           :items="breadcrumbItems"
                           class="mb-md-3"
        />
      </div>
      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>
      <div class="card mt-4 position-relative">
        <div v-if="loading"
          style="position: absolute; height: 100%; width: 100%; z-index: 999; background: rgba(238, 238, 238, 0.5); display: flex; justify-content: center; align-items: center">
          <div uk-spinner="ratio: 4" class="text-info"></div>
        </div>
        <div class="card-body">
          <h4><i class="uil-question-circle"></i> {{ pageTitle }}</h4>
          <hr />
          <div class="row">
            <div class="col-xl-9 m-auto">
              <form action="" novalidate="novalidate">
                <div class="form-group row mb-3 align-items-center">
                  <label class="col-md-3 col-form-label" for="course_title">{{
                    $t("evaluation_survey.name")
                  }}<span class="required">*</span></label>
                  <div class="col-md-9">
                    <input type="text" class="form-control mb-0" id="course_title" name="title" v-model="name"
                      :placeholder="$t('survey.enter_name')" required="" />
                  </div>
                </div>
                <div class="d-flex justify-content-end  align-items-center">
                  <toggle-button :width="120" color="#ae71ff" v-model="is_default" :sync="true"
                    :labels="{ checked: $t('evaluation_survey.default'), unchecked: $t('evaluation_survey.not_default') }" />
                </div>
                <div class="d-flex align-content-center justify-content-end table-vertical-center align-items-center">
                  <toggle-button :width="120" color="#ae71ff" v-model="is_active" :sync="true"
                    :labels="{ checked: $t('evaluation_survey.active'), unchecked: $t('evaluation_survey.inactive') }" />
                </div>
                <hr />
                <div class="questions-area">
                  <div v-for="(question, index) in questions" :key="question._uid" class="question-item">
                    <div class="d-flex justify-content-between survey-question-head">
                      <h4>{{ $t('evaluation_survey.question') }} #{{ index + 1 }}</h4>
                      <button type="button" @click="deleteQuestion(index, question.id)" class="btn btn-outline-danger btn-sm"><i
                          class="uil-trash"></i> {{ $t("evaluation_survey.delete_question") }}</button>
                    </div>
                    <hr>
                    <div class="form-group row mb-3 align-items-center">
                      <label class="col-md-3 col-form-label" :for="'question_name_' + index">
                        {{ $t('evaluation_survey.question_name') }} <span class="required">*</span>
                      </label>
                      <div class="col-md-9">
                        <input type="text" v-model="question.name" :id="'question_name_' + index"
                          :placeholder="$t('evaluation_survey.question_name')" class="mb-0 form-control">
                      </div>
                    </div>
                    <div class="form-group row mb-3 align-items-center">
                      <label class="col-md-3 col-form-label">{{ $t('evaluation_survey.question_type') }}</label>
                      <div class="col-md-9">
                        <span v-if="question.type === 1">{{ $t('general.multiple_choice') }}</span>
                        <span v-if="question.type === 2">{{ $t('evaluation_survey.type_textarea') }}</span>
                      </div>
                    </div>

                    <div v-if="question.type === 1">
                      <hr>
                      <h5>{{ $t('evaluation_survey.options') }}</h5>
                      <hr>
                      <div v-for="(option, optionIndex) in question.options" :key="optionIndex">
                        <div class="survey-option-row">
                          <div class="p-2 survey-option-field survey-option-field--label">
                            <label class="survey-option-label">
                              {{ $t('evaluation_survey.option_label') }} #{{ optionIndex + 1 }}
                            </label>
                            <input type="text" v-model="option.label" class="form-control mb-0">
                          </div>
                          <div class="p-2 survey-option-field survey-option-field--point">
                            <!-- Mobilde kisa metin; CSS ile degistiriliyor ki
                                 resize dinleyicisi gerekmesin -->
                            <label class="survey-option-label">
                              <span class="survey-label--wide">{{ $t('evaluation_survey.option_point') }} #{{ optionIndex + 1 }}</span>
                              <span class="survey-label--narrow">{{ $t('general.point') }} #{{ optionIndex + 1 }}</span>
                            </label>
                            <multiple-select-input :allow-empty="false"
                                                   :searchable="false"
                                                   :show-labels="false"
                                                   :value="pointOption(option, question)"
                                                   :values="pointOptions(question)"
                                                   class="mb-0 survey-point-select"
                                                   @input="option.point = $event ? $event.id : null"
                            />
                          </div>
                          <!-- align-items: flex-end ile hizalaniyor; eskiden
                               `margin-top: 1.8rem` sihirli offseti vardi ve
                               etiket satir kirdiginda hiza kayiyordu. -->
                          <div class="p-2 survey-option-remove" v-if="optionIndex > 1">
                            <button class="uk-button uk-text-warning" type="button"
                              @click="deleteOption(optionIndex, index)"><i class="uil-trash"></i></button>
                          </div>
                        </div>
                      </div>
                      <div class="p-2">
                        <button v-if="question.options.length < 5" class="uk-button uk-button-primary small"
                          type="button" @click="addOption(index)">
                          <i class="uil-plus m-0"></i>{{ $t('general.add_option') }}
                        </button>
                      </div>
                    </div>
                    <div v-if="question.type === 2">
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between survey-add-question">
                  <multiple-select-input v-model="selectedQuestionTypeOption"
                                         :allow-empty="false"
                                         :searchable="false"
                                         :show-labels="false"
                                         :values="questionTypeOptions"
                                         class="mx-1 survey-question-type-select"
                  />
                  <input type="button" @click="addQuestion" class="btn btn-lg btn-outline-primary"
                    :value="$t('evaluation_survey.add_question')" />
                </div>

                <hr>

                <div class="uk-card-footer d-flex justify-content-end pb-0 pr-0 align-items-center survey-form-footer">
                  <button class="uk-button uk-button-primary small" type="button" @click="saveForm">
                    <i class="icon-feather-arrow-right"></i> {{ isEditMode ? $t("general.update") : $t("general.save") }}
                  </button>
                </div>
              </form>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import store from "@/core/services";
import module, {
  BASE_URL,
  MODULE_NAME,
  CREATE_ITEM,
  UPDATE_ITEM,
  GET_ITEM,
  DELETE_QUESTION,
  ITEM,
  LOADING,
  ERROR,
  SUCCESS
} from "@/core/services/store/evaluation_survey.module";
import CompanyBreadcrumb from "@/view/company/components/breadcrumb/CompanyBreadcrumb.vue";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput.vue";

export default {
  name: "AddEditEvaluationSurvey",
  components: { CompanyBreadcrumb, MultipleSelectInput },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule)
      }
    }
    registerStoreModule(MODULE_NAME, module)
  },
  data() {
    return {
      errorMessages: [],
      successMessage: null,
      selected_question_type: 1, // 1: dropdown, 2: textarea
      questions: [],
      questionUidCounter: 0,
      // Duzenlemede de YEREL tutuluyor: eski Edit.vue store getter'inin
      // dondurdugu nesneyi dogrudan mutasyona ugratiyordu (Vuex disi yazma).
      name: null,
      is_active: true,
      is_default: false,
    }
  },
  computed: {
    isEditMode() {
      return !!this.$route.params.id;
    },
    pageTitle() {
      return this.isEditMode
          ? this.$t("evaluation_survey.edit")
          : this.$t("evaluation_survey.add");
    },
    breadcrumbItems() {
      return [
        { name: this.$t("general.surveys") },
        { name: this.pageTitle },
      ];
    },
    questionTypeOptions() {
      return [
        { id: 1, name: this.$t("general.multiple_choice") },
        { id: 2, name: this.$t("evaluation_survey.type_textarea") },
      ];
    },
    // MultipleSelectInput nesne bekliyor, selected_question_type ise sayi
    selectedQuestionTypeOption: {
      get() {
        return this.questionTypeOptions.find((o) => o.id === this.selected_question_type)
            || this.questionTypeOptions[0];
      },
      set(value) {
        this.selected_question_type = value && value.id ? value.id : 1;
      },
    },
    loading: {
      get() {
        return store.getters[MODULE_NAME + "/" + LOADING];
      },
      set(value) { },
    },
    surveyItem: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEM];
      },
      set(value) { },
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set(value) { },
    },
    success: {
      get() {
        return store.getters[MODULE_NAME + "/" + SUCCESS];
      },
      set(value) { },
    },
  },
  methods: {
    pointOptions(question) {
      return question.options.map((_, i) => ({ id: i + 1, name: String(i + 1) }));
    },
    pointOption(option, question) {
      return this.pointOptions(question).find((o) => o.id === Number(option.point)) || null;
    },
    getItem() {
      store.dispatch(MODULE_NAME + '/' + GET_ITEM, {
        url: BASE_URL + '/' + this.$route.params.id,
      })
    },
    // API'den gelen anketi forma tasir. options string ya da dizi gelebiliyor.
    loadSurveyData() {
      const item = this.surveyItem;
      if (!item) return;

      this.name = item.name;
      this.is_active = parseInt(item.is_active) === 1;
      this.is_default = parseInt(item.is_default) === 1;

      if (this.questions.length === 0 && Array.isArray(item.questions)) {
        this.questions = item.questions.map((question) => {
          let options = [];
          if (question.options) {
            options = Array.isArray(question.options)
                ? question.options
                : JSON.parse(question.options);
          }
          return {
            _uid: ++this.questionUidCounter,
            id: question.id,
            name: question.name,
            type: question.type,
            options: Array.isArray(options) ? options : []
          };
        });
      }
    },
    deleteOption(optionIndex, questionIndex) {
      this.questions[questionIndex].options.splice(optionIndex, 1);
      this.questions[questionIndex].options.forEach((option, index) => {
        option.point = index + 1;
      });
    },
    addOption(questionIndex) {
      this.questions[questionIndex].options.push({
        label: null,
        point: this.questions[questionIndex].options.length + 1,
      });
    },
    saveForm() {
      let self = this;
      let validated = true;

      if (self.name == null || self.name.length < 3) {
        this.errorMessages.push(
          self
            .$t("validation.required_field")
            .replace(":NAME", self.$t("evaluation_survey.name"))
        );
        self.scrollToTop();
        validated = false;
      }

      if (self.questions.length === 0) {
        this.errorMessages.push(
          this.$t("validation.required_field").replace(
            ":NAME",
            self.$t("evaluation_survey.questions")
          )
        );
        self.scrollToTop();
        validated = false;
      }

      self.questions.forEach(question => {
        if (question.name == null) {
          this.errorMessages.push(
            self
              .$t("validation.required_field")
              .replace(":NAME", self.$t("evaluation_survey.question_name"))
          );
          self.scrollToTop();
          validated = false;
        }
        question.options.forEach(option => {
          if (option.label == null) {
            this.errorMessages.push(
              self
                .$t("validation.required_field")
                .replace(":NAME", self.$t("evaluation_survey.option_label"))
            );
            self.scrollToTop();
            validated = false;
          }
        });
      });

      if (!validated) return;

      const questions = self.questions.map((question) => {
        const payload = Object.assign({}, question);
        payload.options = JSON.stringify(question.options);
        // Olusturmada id gonderilmez; `id: 0` backend'de "0 numarali soruyu
        // guncelle" diye yorumlanabilir.
        if (!self.isEditMode) {
          delete payload.id;
        }
        return payload;
      });

      const contents = {
        name: self.name,
        is_active: self.is_active,
        is_default: self.is_default,
        questions: questions
      };

      if (self.isEditMode) {
        store.dispatch(MODULE_NAME + "/" + UPDATE_ITEM, {
          url: BASE_URL + "/" + self.$route.params.id,
          contents,
        });
      } else {
        store.dispatch(MODULE_NAME + "/" + CREATE_ITEM, {
          url: BASE_URL,
          contents,
        });
      }
    },
    addDropdownQuestion() {
      this.questions.push({
        _uid: ++this.questionUidCounter,
        id: 0,
        name: null,
        type: 1,
        options: [
          { label: null, point: 1 },
          { label: null, point: 2 }
        ]
      });
    },
    addTextareaQuestion() {
      this.questions.push({
        _uid: ++this.questionUidCounter,
        id: 0,
        name: null,
        type: 2,
        options: []
      });
    },
    addQuestion() {
      switch (this.selected_question_type) {
        case 1:
          this.addDropdownQuestion();
          break;
        case 2:
          this.addTextareaQuestion();
          break;
      }
    },
    // id > 0 ise soru sunucuda da kayitli; once orada silinir.
    deleteQuestion(index, id) {
      if (this.isEditMode && id > 0) {
        store.dispatch(MODULE_NAME + '/' + DELETE_QUESTION, {
          url: BASE_URL + '/delete-question/' + id
        });
      }
      this.questions.splice(index, 1);
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  watch: {
    surveyItem: {
      handler() {
        if (this.isEditMode) {
          this.loadSurveyData();
        }
      },
      immediate: true,
    },
    success: function (val) {
      if (val) {
        this.successMessage = this.isEditMode
            ? this.$t("general.successfully_updated")
            : this.$t("general.successfully_created");
        this.$router.push({ name: "company.evaluation-surveys.list" });
      }
    },
    // Eski Add.vue'da bu watcher `errors` adiyla yazilmisti; boyle bir
    // computed olmadigi icin store hatalari hic gorunmuyordu.
    error: function (val) {
      if (val) {
        this.scrollToTop();
        this.errorMessages.push(val);
      }
    },
    successMessage() {
      this.debouncedResetValues();
    },
    errorMessages() {
      this.debouncedResetValues();
    },
  },
  mounted() {
    if (this.isEditMode) {
      this.getItem();
    } else {
      this.addDropdownQuestion();
    }
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 5000);
  },
}
</script>

<style scoped>
.question-item {
  background: rgb(251, 251, 251);
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid #efefef;
}

/* ── Soru basligi ── */
.survey-question-head {
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.survey-question-head h4 {
  margin: 0;
  min-width: 0;
}

/* ── Secenek satiri ──
   align-items: flex-end ile sil butonu input'larla hizalaniyor;
   eskiden butona `margin-top: 1.8rem` veriliyordu ve etiket satir
   kirdiginda hiza kayiyordu. */
.survey-option-row {
  /* Uc kontrol de ayni yuksekligi bu degiskenden aliyor */
  --survey-control-h: 38px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}

/* 1) metin input'u */
.survey-option-row .form-control {
  box-sizing: border-box;
  height: var(--survey-control-h);
  min-height: var(--survey-control-h);
}

/* 2) puan dropdown'i (MultipleSelectInput -> vue-multiselect) */
.survey-option-row ::v-deep .multiselect,
.survey-option-row ::v-deep .multiselect__tags {
  box-sizing: border-box;
  height: var(--survey-control-h);
  min-height: var(--survey-control-h);
}

.survey-option-row ::v-deep .multiselect__tags {
  display: flex;
  align-items: center;
  padding: 0 32px 0 10px;
}

.survey-option-row ::v-deep .multiselect__single,
.survey-option-row ::v-deep .multiselect__placeholder,
.survey-option-row ::v-deep .multiselect__input {
  margin: 0;
  padding: 0;
  line-height: 1.4;
}

.survey-option-row ::v-deep .multiselect__select {
  top: 0;
  height: var(--survey-control-h);
}

/* 3) sil butonu — kare, ayni yukseklik */
.survey-option-remove .uk-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: var(--survey-control-h);
  height: var(--survey-control-h);
  min-height: var(--survey-control-h);
  padding: 0;
  line-height: 1;
}

.survey-option-field {
  min-width: 0;
}

.survey-option-field--label {
  flex: 1 1 220px;
}

.survey-option-field--point {
  flex: 0 0 auto;
}

/* Icerige gore genislesin; sabit deger yok, sadece cokme sinirini koruyan
   bir min-width. Ok icin sagda 32px yer birakiliyor. */
.survey-option-field--point ::v-deep .multiselect {
  width: auto;
  min-width: 72px;
}

/* WEB_UI_GUIDELINES: Label 14px/500, line-height 1.3-1.5
   (eskiden 13px idi; mobil guideline'da da label 14px) */
.survey-option-label {
  display: block;
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
}

.survey-label--narrow {
  display: none;
}

/* ── Soru ekleme satiri ── */
.survey-add-question {
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.survey-question-type-select {
  max-width: 200px;
}

/* ── Form altligi ──
   Eskiden ikinci butonda `margin-left: 5vh` vardi: yatay bosluk icin
   VIEWPORT YUKSEKLIGI birimi. Kisa/genis ekranda daraliyor, uzun
   telefonda buyuyordu. Yerine sabit gap. */
.survey-form-footer {
  flex-wrap: wrap;
  gap: 8px;
}

/* MultipleSelectInput koku .form-group; alt margin'i satiri sisiriyor */
.survey-option-row .form-group,
.survey-add-question .form-group {
  margin-bottom: 0;
}

@media (max-width: 767px) {
  .question-item {
    padding: 12px;
  }

  .survey-option-row {
    --survey-control-h: 44px;
  }

  /* Input + puan dropdown'i + sil ikonu AYNI satirda */
  .survey-option-row {
    flex-wrap: nowrap;
    gap: 4px;
  }

  .survey-option-row .p-2 {
    padding: 4px !important;
  }

  .survey-option-field--label {
    flex: 1 1 auto;
  }

  .survey-option-field--point {
    flex: 0 0 auto;
  }

  /* Dar ekranda "Secenek Puani #1" yerine kisa etiket */
  .survey-label--wide {
    display: none;
  }

  .survey-label--narrow {
    display: inline;
  }

  .survey-question-type-select {
    flex: 1 1 100%;
    max-width: none;
  }

  .survey-add-question {
    flex-direction: column;
    align-items: stretch;
  }

  .survey-add-question .btn {
    width: 100%;
    min-height: 48px;
  }

  /* Kaydet + Atama yap ayni satirda, esit paylasimli */
  .survey-form-footer {
    flex-wrap: nowrap;
  }

  .survey-form-footer .uk-button {
    flex: 1 1 0;
    min-width: 0;
    min-height: 48px;
    /* MOBILE_UI_GUIDELINES: Body 16px */
    font-size: 16px;
    line-height: 1.4;
  }
}
</style>
